import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_ERROR_EVENT, ApiErrorEventDetail } from '../../lib/api';

export default function ApiErrorNavigationHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onApiError = (event: Event) => {
      const customEvent = event as CustomEvent<ApiErrorEventDetail>;
      const detail = customEvent.detail;
      if (!detail?.status) {
        return;
      }

      const currentPath = location.pathname;
      if (currentPath.startsWith('/error/')) {
        return;
      }

      const state = {
        requestId: detail.requestId || null,
        message: detail.message || null,
        from: `${location.pathname}${location.search}`
      };

      if (detail.status === 401) {
        navigate('/error/401', { replace: true, state });
        return;
      }

      if (detail.status === 403) {
        navigate('/error/403', { replace: true, state });
        return;
      }

      if (detail.status === 404 && detail.navigateToNotFound) {
        navigate('/error/404', { replace: true, state });
        return;
      }

      if (detail.status === 503) {
        navigate('/error/503', { replace: true, state });
        return;
      }

      if (detail.status >= 500) {
        navigate('/error/500', { replace: true, state });
      }
    };

    window.addEventListener(API_ERROR_EVENT, onApiError as EventListener);
    return () => window.removeEventListener(API_ERROR_EVENT, onApiError as EventListener);
  }, [location.pathname, location.search, navigate]);

  return null;
}
